import * as couponViewTypes from "../types/couponViewTypes";
import * as couponViewServices from "../../services/couponViewServices";

/**
 * Record one view per browser tab session per coupon (sessionStorage).
 * @param {string} couponPublicId
 * @param {{ anonKey?: string }} [opts]
 */
export const recordCouponViewOnce =
  (couponPublicId, opts = {}) =>
  async (dispatch) => {
    if (!couponPublicId) return;
    const seenKey = `couponView:${couponPublicId}`;
    if (typeof window !== "undefined" && window.sessionStorage.getItem(seenKey)) {
      return;
    }
    dispatch({
      type: couponViewTypes.RECORD_COUPON_VIEW_REQUEST,
      payload: { couponPublicId },
    });
    try {
      let anonKey = opts.anonKey;
      if (!anonKey && typeof window !== "undefined") {
        anonKey = window.sessionStorage.getItem("coupondealz_anon");
        if (!anonKey) {
          anonKey = `${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
          window.sessionStorage.setItem("coupondealz_anon", anonKey);
        }
      }
      await couponViewServices.recordCouponView(couponPublicId, {
        anonKey: anonKey || "",
      });
      if (typeof window !== "undefined") {
        window.sessionStorage.setItem(seenKey, "1");
      }
      dispatch({
        type: couponViewTypes.RECORD_COUPON_VIEW_SUCCESS,
        payload: { couponPublicId },
      });
    } catch (e) {
      dispatch({
        type: couponViewTypes.RECORD_COUPON_VIEW_FAILURE,
        payload:
          e?.response?.data?.message || e?.message || "Failed to record view",
      });
    }
  };
